import {amaronScheduleCallStrategy} from "~/domainModels/scheduleCall/amaronScheduleCallStrategy";
import {bobcardScheduleCallStrategy} from "~/domainModels/scheduleCall/bobcardScheduleCallStrategy";
import {dhiraaguScheduleCallStrategy} from "~/domainModels/scheduleCall/dhiraaguScheduleCallStrategy";
import {duluxScheduleCallStrategy} from "~/domainModels/scheduleCall/duluxScheduleCallStrategy";
import {emotoradScheduleCallStrategy} from "~/domainModels/scheduleCall/emotoradScheduleCallStrategy";
import type {ScheduleCallStrategy} from "~/domainModels/scheduleCall/scheduleCallStrategy";
import type {OttopilotEventTemplate} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventsWorkspaceCapability/domain/OttopilotEventTemplate";
import type {WorkspaceCapability} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapability";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import {isAmaronWorkspace} from "~/domainModels/workspaceSpecific/amaron";
import {isBobcardWorkspace} from "~/domainModels/workspaceSpecific/bobcard";
import {isDhiraaguWorkspace} from "~/domainModels/workspaceSpecific/dhiraagu";
import {isDuluxWorkspace} from "~/domainModels/workspaceSpecific/dulux";
import {isEmotoradWorkspace} from "~/domainModels/workspaceSpecific/emotorad";

export function resolveScheduleCallStrategy(
    workspace: {displayName: string; id?: string},
    workspaceCapabilities: ReadonlyArray<WorkspaceCapability<WorkspaceCapabilityType>>,
    eventTemplates: Array<OttopilotEventTemplate>,
): ScheduleCallStrategy | null {
    const candidate =
        isEmotoradWorkspace(workspace) === true
            ? emotoradScheduleCallStrategy
            : isAmaronWorkspace(workspaceCapabilities) === true
              ? amaronScheduleCallStrategy
              : isDuluxWorkspace(workspaceCapabilities) === true
                ? duluxScheduleCallStrategy
                : isBobcardWorkspace(workspace) === true
                  ? bobcardScheduleCallStrategy
                  : isDhiraaguWorkspace(workspace) === true
                    ? dhiraaguScheduleCallStrategy
                    : null;

    if (candidate === null) {
        return null;
    }

    const callTemplate = candidate.resolveCallEventTemplate(eventTemplates);
    if (callTemplate === undefined) {
        return null;
    }

    return candidate;
}

/** @deprecated Use `resolveScheduleCallStrategy` */
export const resolveListScheduleCallStrategy = resolveScheduleCallStrategy;
